import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { MenuDetailPage } from 'src/app/menu/menu-detail/menu-detail.page';
import { ConfigService } from 'src/app/provider/config.service';

@Component({
  selector: 'macros-bar',
  templateUrl: './macros-bar.component.html',
  styleUrls: ['./macros-bar.component.scss'],
})
export class MacrosBarComponent implements OnInit {
  private _color?: string;
  private _selectedColor?: string;
  private _Tcolor?: string;
  private _selectedTColor?: string;

  @Input()
  set color(value: string | undefined) {
    this._color = value;
    this._Tcolor = value;
  }

  @Input()
  set selectedColor(value: string | undefined) {
    this._selectedColor = value;
    this._selectedTColor = value;
  }
    @HostBinding('style.--macro-color')
  get buttonColor(): string | null {
    return this._color ? `var(--ion-color-${this._color})` : `${this._selectedColor}` ? `var(--ion-text-${this._selectedColor})` : 'var(--ion-color-primary)';
  }

  @HostBinding('style.--name-color')
  get buttonSelectedColor(): string | null {
    return this._color ? `var(--ion-color-${this._color})` : `${this._selectedColor}` ? `var(--ion-text-${this._selectedColor})` : 'var(--ion-color-primary)';
  }
      @HostBinding('style.--macro-dark')
  get buttonTColor(): string | null {
    return this._Tcolor ? `var(--ion-text-${this._color})` : null;
  }

  @HostBinding('style.--name-dark')
  get buttonSelectedTColor(): string | null {
    return this._selectedTColor ? `var(--ion-text-${this._selectedColor})` : null;
  }
//  item: any;
  @Input() buttonText?: string;

  @Input() iconSrc?: string;
  storeData: any;
  @Input() isForceFixedMenu: boolean = false;
  @Input() is_variable_carbs: boolean;
    @Input() item: any;
  settings: any;
 

   @Input() typeFood: any; 

  @Input() disabled: boolean = false;
  @Input() isActive: boolean = false;


  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private configService: ConfigService,
  ) {
        this.configService.getAppSettings().then((settingData: any) => {
      this.settings = JSON.parse(settingData);
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
    });
    
  }
  async ngOnInit() { 

  }


    getShortTitle = (data: string) => {
    if (data.length > 200) {
      return data.substring(0, 39) + "...";
    }
    return data;
  }
  getShortDesc = (data: string) => {
    if (data.length > 500) {
      return data.substring(0, 49) + "...";
    }
    return data;
  }
    getParseFloat = (num: any) => {
    return Number(parseFloat(num).toFixed(0));
  }

}